<template>
  <div>
    <HeaderSub :isShowStatus="true"/>
    <BannerUser :integralInfo="integralInfo"/>
    <div class="userinfo base-div clearfix">
			<div class="userinfo_nav">
				<ul class="userinfo-nav-list">
					<li class="active">
						<router-link to="/userinfo/baseinfo">基本信息</router-link>
					</li>
					<li>
						<a href="javascript:;" class="disabled">我的消息</a>
					</li>
					<li>
						<router-link to="/userinfo/mytask">我的任务</router-link>
					</li>
					<li>
						<a href="javascript:;"  class="disabled">我的活动</a>
					</li>
					<li>
						<router-link to="/userinfo/messageMy">我的留言</router-link>
					</li>
					<!-- <li>
						<router-link to="/userinfo/account">账号设置</router-link>
					</li> -->
					<li v-if="cloudResourceFlag==1">
						<router-link to="/userinfo/clondResourse">云适配资源申请</router-link>
					</li>
				</ul>
			</div>
			<div class="userinfo-cnt">
				<router-view @userInfoChange="userInfoChange"/>
			</div>
		</div>
  </div>
</template>

<script>
import qs from 'qs'
import { post,ajaxParam } from '../../units/request.js'
import HeaderSub from '../../components/HeaderSub'
import BannerUser from '../../components/BannerUser'
export default {
  name: 'Userinfo',
  data(){
	return{
		integralInfo: {},
		cloudResourceFlag: ''
	}
  },
  components: {
    HeaderSub,
    BannerUser
  },
  methods: {
	//获取用户积分信息
	async getUserIntegral(){
		let url = 'v1/integral/getUserIntegral'
		let param = {
			userId: this.userId,
      token:localStorage.getItem('token'),
			activityId: this.activityId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.integralInfo = res.data.entity
		} else {
			this.$message.error(res.data.msg)
		}
	},
	userInfoChange(){
		this.userId = localStorage.getItem('userId')
		this.activityId = localStorage.getItem('activityId')
		this.getUserIntegral()
	}
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.activityId = localStorage.getItem('activityId')
	let activeInfo = localStorage.getItem('activeInfo')
	activeInfo = JSON.parse(activeInfo)
	this.cloudResourceFlag = activeInfo.cloudResourceFlag
	this.getUserIntegral()
	window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.userinfo{position: relative; padding: 40px 0;}
.userinfo_nav{float:left; width: 162px; position: absolute; top: 40px; left: 0;}
.userinfo-cnt{
	float: right;
	width: 88%;
	min-height: 300px;
	/* padding-bottom: 86px; */
	box-sizing: border-box;
}
.userinfo-cnt h3{line-height: 74px; font-size: 20px; font-weight: bold;}
.userinfo-nav-list li{height: 38px; margin-bottom: 20px; background: #fff; text-align: center; color:#fff; line-height: 38px;}
.userinfo-nav-list li a{display:block; width: 100%; height: 100%; color:#000}
.userinfo-nav-list li a.router-link-active{background: #DE0515; color:#fff}
.userinfo-nav-list li a.disabled{color:#D2D2D2}
</style>
